function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.303 17.3338V8.76339C43.3031 7.1497 42.6656 5.60134 41.5294 4.45546C40.3932 3.30958 38.8503 2.659 37.2366 2.64539H28.6534",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3337 2.64539H8.76336C7.14077 2.64539 5.58463 3.28996 4.43728 4.43731C3.28993 5.58466 2.64536 7.1408 2.64536 8.76339V17.3338",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6534 43.303H37.2366C38.8414 43.2896 40.3765 42.6461 41.5113 41.5113C42.6461 40.3766 43.2895 38.8414 43.303 37.2367V28.6534",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5415 21.8126L30.5765 23.0904L27.9951 26.9625L21.5415 25.504V21.8126Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5415 32.6804V35.5587C21.544 35.9076 21.6785 36.2427 21.9179 36.4965C22.1574 36.7503 22.484 36.9041 22.8322 36.9269L27.8402 37.2625C28.0273 37.2749 28.215 37.2486 28.3915 37.1855C28.5681 37.1223 28.7298 37.0235 28.8666 36.8952C29.0033 36.7668 29.1123 36.6118 29.1866 36.4396C29.261 36.2675 29.2991 36.0818 29.2987 35.8943V34.7069",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M40.2182 23.697C39.6219 23.7615 39.0204 23.7615 38.4241 23.697L30.5765 23.1033",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6116 29.5053C38.9208 29.503 38.231 29.4555 37.5464 29.3633L29.2858 28.2662L27.9951 26.9755",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6632 20.0701C38.9533 20.0701 38.2434 20.0701 37.5464 20.0701L22.8322 19.2698L21.5415 21.8513",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6116 8.80213H30.3958C29.6933 8.80084 29.0044 8.99595 28.4068 9.36542C27.8093 9.73489 27.3269 10.264 27.0141 10.8931L22.8838 19.2311",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6115 35.7782L27.9951 34.4874L21.4769 32.6546C21.169 32.5654 20.8982 32.3789 20.7051 32.1229C20.512 31.867 20.4069 31.5554 20.4056 31.2348V27.879C20.3995 27.2894 20.5954 26.7155 20.9607 26.2526L21.5415 25.504",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M2.64536 28.6534V37.2367C2.65897 38.8503 3.30955 40.3932 4.45543 41.5294C5.60131 42.6656 7.14967 43.3031 8.76336 43.303H17.3337",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0289 39.2889C14.9658 39.2889 17.3466 36.9081 17.3466 33.9711C17.3466 31.0342 14.9658 28.6534 12.0289 28.6534C9.09196 28.6534 6.71112 31.0342 6.71112 33.9711C6.71112 36.9081 9.09196 39.2889 12.0289 39.2889Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0289 36.3203C11.8406 36.3203 11.66 36.395 11.5269 36.5282C11.3938 36.6613 11.319 36.8419 11.319 37.0301C11.3054 37.1305 11.3134 37.2326 11.3425 37.3297C11.3716 37.4267 11.4211 37.5163 11.4878 37.5926C11.5544 37.6689 11.6366 37.7301 11.7288 37.772C11.821 37.8139 11.9211 37.8355 12.0224 37.8355C12.1237 37.8355 12.2238 37.8139 12.3161 37.772C12.4083 37.7301 12.4905 37.6689 12.5571 37.5926C12.6237 37.5163 12.6733 37.4267 12.7024 37.3297C12.7315 37.2326 12.7395 37.1305 12.7259 37.0301C12.7259 36.8441 12.6529 36.6655 12.5225 36.5327C12.3922 36.3999 12.2149 36.3236 12.0289 36.3203Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3448 30.8734V34.5907C11.3448 34.7687 11.4155 34.9394 11.5414 35.0652C11.6673 35.1911 11.838 35.2618 12.016 35.2618C12.194 35.2618 12.3647 35.1911 12.4906 35.0652C12.6164 34.9394 12.6872 34.7687 12.6872 34.5907V30.8734C12.6872 30.6954 12.6164 30.5247 12.4906 30.3988C12.3647 30.2729 12.194 30.2022 12.016 30.2022C11.838 30.2022 11.6673 30.2729 11.5414 30.3988C11.4155 30.5247 11.3448 30.6954 11.3448 30.8734Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
function SvgWrongPose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongPose);
export default __webpack_public_path__ + "static/media/wrong-pose.a3ede8a8ab64966304ec3d2aecfac44e.svg";
export { ForwardRef as ReactComponent };